export const likeSamePathRoutes = [
    '/sejours/models/',
    '/sejours/events/'
]

export const noLoadingScreenRoutes = [
    '/login', 
    '/reset-password'
];